import BaseApi from '../baseApi';

export default class ExchangeStoreApi extends BaseApi {
  constructor(obj){
    obj = obj || {};
    super(obj);
  }

  add(store, bankId) {
    store = store || {};

    return new Promise((resolve, reject) => {
      return this.api
        .post(`/exchange-banks/${bankId}/exchange-stores`, store)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  update(store, bankId) {
    store = store || {};

    return new Promise((resolve, reject) => {
      return this.api
        .put(`/exchange-banks/${bankId}/exchange-stores/${store.id}`, store)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findByBank(bankId) {
    return new Promise((resolve, reject) => {
      return this.api
        .get(`/exchange-banks/${bankId}/exchange-stores`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findId(storeId, bankId) {
    storeId = storeId || {};

    return new Promise((resolve, reject) => {
      return this.api
        .get(`/exchange-banks/${bankId}/exchange-stores/${storeId}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

  findCities() {
    return new Promise((resolve, reject) => {
      return this.api
        .get(`/exchange-banks/exchange-stores/cities`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }
}
